export const WELCOME_KIT_TAG = 'welcome_kit';

export const SHOPIFY_METAFIELDS_IDENTIFIERS = [
  {
    key: 'current_price',
    namespace: 'custom'
  },
  {
    key: 'original_price',
    namespace: 'custom'
  },
  {
    key: 'label',
    namespace: 'custom'
  },
  {
    key: 'url',
    namespace: 'custom'
  },
  {
    // product level metafield
    key: 'short_description',
    namespace: 'custom'
  },
  {
    key: 'frequency_note',
    namespace: 'custom'
  },
  {
    key: 'original_price_footnote',
    namespace: 'custom'
  },
  {
    // product level metafield
    key: 'alternative_title',
    namespace: 'custom'
  },
  {
    key: 'core_product_quantity',
    namespace: 'custom'
  },
  {
    key: 'core_product_alternative_title',
    namespace: 'custom'
  },
  {
    key: 'core_product_selling_plan_id',
    namespace: 'custom'
  },
  {
    key: 'core_product_servings_description',
    namespace: 'custom'
  },
  {
    // product level metafield
    key: 'use_custom_bundle_servings_description',
    namespace: 'custom'
  },
  {
    key: 'current_price_prefix',
    namespace: 'custom'
  },
  {
    key: 'flavor',
    namespace: 'custom'
  }
];
